/**
 * The six digits a member types to get in.
 *
 * The link in the email only logs in the device that opens it, which is the wrong device
 * whenever mail is on the phone and the game is on a laptop. The code closes that gap: it is
 * read on one device and typed on another, so the browser that asked is the browser that ends
 * up logged in.
 *
 * Digits only, so there is nothing to explain about case, and no 0/O or 1/l to misread.
 */

export const CODE_LENGTH = 6;

/** Everything the member could plausibly paste — "123 456", "123-456", " 123456 " — is the same code. */
export function normaliseCode(input: string): string {
  return input.replace(/\D+/g, '').slice(0, CODE_LENGTH);
}

export function looksLikeCode(input: string): boolean {
  return new RegExp(`^\\d{${CODE_LENGTH}}$`).test(input);
}

/** Grouped for reading aloud and for copying off a phone screen. */
export function formatCode(code: string): string {
  const digits = normaliseCode(code);
  if (digits.length !== CODE_LENGTH) return digits;
  return `${digits.slice(0, 3)} ${digits.slice(3)}`;
}
